import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux'

import { Address, AddressActionCreators } from '../models'

import AddressDisplay from './AddressDisplay';
import RadioInput from './RadioInput';
import ActiveAddressInAddressSelectorListContainer from './ActiveAddressInAddressSelectorListContainer'

import {
    hiddenAnchorStyle,
    pretendAnchorStyle
} from './styles'
import { Fade } from '../componentAnimations'


class AddressSelectorList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeAddressId: ''
        };

        this.onDeleted = this.onDeleted.bind(this);
        this.onSelected = this.onSelected.bind(this);
        this.onItemClick = this.onItemClick.bind(this);
        this.onRadioSelected = this.onRadioSelected.bind(this);
    }

    beginEdit(Id) {
        if (this.state.activeAddressId !== '') {
            // Only set active if we had an active before
            this.setState({ activeAddressId: Id });
        }
        this.props.onBeginEdit(Id);
    }

    onRadioSelected(id) {
        this.setState({ activeAddressId: id });
        this.props.onAddressSelected(id);
    }

    onSelected(id) {
        this.props.onAddressSelected(id);
        this.props.onDoneSelecting(id);
        this.setState({ activeAddressId: '' });
    }

    onDeleted(id) {
        this.setState({ activeAddressId: '' });
    }

    onItemClick(id) {
        this.setState({ activeAddressId: id });
    }

    render() {
        const listComponent = this;
        const props = this.props;
        const listItems = this.props.addresses.map((address) => {
            const isSelected = props.selectedAddressId === address.Id;
            const focused = listComponent.state.activeAddressId === address.Id;
            if (focused) {
                return (
                    <ActiveAddressInAddressSelectorListContainer
                        key={address.Id}
                        address={address}
                        selectAddressActionCreator={props.addressActionCreators.select}
                        deleteAddressActionCreator={props.addressActionCreators.remove}
                        selectAddressMessage={props.selectAddressMessage}
                        onBeginEdit={(id) => listComponent.beginEdit(id)}
                        isSelected={isSelected}
                        onSelected={() => listComponent.onSelected(address.Id)}
                        onRadioSelected={() => listComponent.onRadioSelected(address.Id)}
                        onDeleted={() => listComponent.onDeleted(address.Id)}
                    />
                );
            } else {
                return (
                    <div
                        key={address.Id}
                        style={{ marginTop: 7, marginBottom: 7 }}
                    >
                        <div
                            style={{ display: 'flex', alignItems: 'center' }}
                        >
                            <RadioInput
                                selected={isSelected}
                                onClick={
                                    () => listComponent.onRadioSelected(address.Id, listComponent.props.useForAnotherSelected)}
                            />
                            <div
                                className={`address ${isSelected ? 'selected' : ''}`}
                            >
                                <a
                                    href=""
                                    style={hiddenAnchorStyle}
                                    onClick={(e) => { e.preventDefault(); listComponent.onItemClick(address.Id); }}
                                >
                                    <AddressDisplay address={address} compact={true} />
                                </a>
                            </div>
                            <div className='col-2'>
                                <a title='edit' href='' onClick={(e) => {
                                    e.preventDefault();
                                    listComponent.beginEdit(address.Id);
                                }}>
                                    <span
                                        style={pretendAnchorStyle}
                                        className='far fa-edit'
                                    ></span>
                                </a>
                            </div>
                        </div>

                    </div>
                );
            }
        });

        return (
            <div>
                {listItems}
                <a
                    href='#'
                    style={{ marginTop: 15, fontWeight: 600, display: 'block' }}
                    onClick={() => this.beginEdit()}>Add New</a>
            </div>
        )
    }
}

AddressSelectorList.propTypes = {
    addresses: PropTypes.arrayOf(Address.propTypes).isRequired,
    selectedAddressId: PropTypes.string,
    selectAddressMessage: PropTypes.string.isRequired,
    onDoneSelecting: PropTypes.func.isRequired,
    onAddressSelected: PropTypes.func.isRequired,
    addressActionCreators: PropTypes.shape(AddressActionCreators).isRequired
}

const mapDispatchToProps = (dispatch, ownProps) => ({
    onAddressSelected: (id, address) => dispatch(ownProps.addressActionCreators.select(id, address))
})

const AddressSelectorListContainer = connect(
    null,
    mapDispatchToProps
)(AddressSelectorList)

export default AddressSelectorListContainer;


// WEBPACK FOOTER //
// ./src/Components/checkout/components/AddressSelectorList.jsx